<template lang="html">
  <div class="share-bubble">
    <div class="share-bubble-main" @click="closeBubble">
      <template v-if="!encourageType">
        <h1>打卡成功!</h1>
        <img class="share-bubble-main-bg" src="./.default/share-pop.png" alt="">
        <img src="./.default/close.png" alt="" class="share-bubble-main-close">
        <p>坚持就是胜利哦~</p>
      </template>
      <template v-if="encourageType === 2 && leftChapters">
        <h1>打卡成功!</h1>
        <img class="share-bubble-main-bg" src="./.default/share-pop.png" alt="">
        <img src="./.default/close.png" alt="" class="share-bubble-main-close">
        <p class="para">距离您<span>领学费还差{{leftChapters}}节</span></p>
        <p>坚持就是胜利哦~</p>
      </template>
      <template v-if="encourageType === 2 && !leftChapters">
        <h1>打卡成功!</h1>
        <img class="share-bubble-main-bg" src="./.default/share-pop.png" alt="">
        <img src="./.default/close.png" alt="" class="share-bubble-main-close">
        <!--<p class="para">距离您<span>领学费还差{{leftChapters}}节</span></p>-->
        <p>恭喜您成功领取代金券~</p>
      </template>
      <template v-if="encourageType === 1 && !encourageValue">
        <h1>打卡成功!</h1>
        <img class="share-bubble-main-bg" src="./.default/share-pop2.png" alt="">
        <p>您今天已领过红包了，明</p>
        <p>天再来吧</p>
      </template>
    </div>
    <div class="share-bubble-money" v-if="encourageType === 1  && encourageValue">
      <div class="share-bubble-money-main" @click="toPage">
        <p>恭喜您获得<span>{{encourageValue}}</span>元</p>
        <!--<p>恭喜您成功领取~</p>-->
      </div>
      <div class="share-bubble-money-close"  @click="closeBubble">
        <img src="../../assets/images/live-share-close.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '../UI/Button'
export default {
  name: 'ShareBubble',
  props: ['leftChapters', 'encourageType', 'encourageValue', 'courseName'],
  data () {
    return {
      bubbleShow: false
    }
  },
  methods: {
    closeBubble () {
      this.$emit('closeBubble')
    },
    toPage () {
      this.$router.push('/money')
    }
  },
  components: {
    UIButton
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.share-bubble {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .5);
  z-index:999;
  &-btn {
    border-radius: rem(50);
    margin: 0 auto;
  }
  &-main {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width:rem(430);
    height: rem(370);
    text-align: center;
    padding-top: rem(134);
    &-close {
      width: rem(20);
      position: absolute;
      top: rem(49);
      right: rem(8);
    }
    &-bg {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
    }
    h1 {
      color: #333;
      font-weight: bolder;
      font-size: rem(30);
      margin-bottom: rem(27);
    }
    p {
      font-size: rem(28);
      color: #999;
      line-height: 1.6;
    }
    .para {
      color: #F5A623;
    }
  }
  &-money {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &-close {
      width: rem(60);
      > img {
        width: 100%;
      }
    }
    &-main {
      width: rem(500);
      height: rem(584);
      background: url("./.default/money-pop.png");
      background-size: contain;
      position: relative;
      margin-bottom: rem(45);
      > p {
        position: absolute;
        top: rem(94);
        font-size: rem(34);
        line-height: 2;
        width: 100%;
        text-align: center;
        > span {
          color: #FF4E00;
          font-size: rem(36);
        }
      }
    }
  }
}
</style>
